import axios from 'axios'
import { BOT_URL } from '../constants/url'

export const sendBotMessage = (message, subMessage) => {
  axios
    .post(`${BOT_URL}/message`, {
      origin: 'Pinmap pro',
      message,
      sub_message: subMessage,
      type: 'checkoutError'
    })
    .catch(err => {
      console.error(err)
    })
}

export const buildMessage = (shippingRates, cartData, companyInfo, addressInfo) => {
  const { lines, total, totalWeight } = cartData
  const { companyName } = companyInfo
  const { userAddress, district, region } = addressInfo
  let message = 'Error: '
  message += shippingRates
    ? 'Pinflag Shipping Rate did not provide a rate\n'
    : 'Shopify did not provide any rate\n'
  message += `Company: ${companyName}\n`
  message += `Address: ${userAddress}, ${district}, ${region}\n`
  message += `CartData: Total: $${total}, Weight: ${totalWeight}\n`
  for (let index = 0; index < lines.length; index++) {
    message += ` - Product ${index + 1}: id: ${lines[index].id}, name: ${lines[index].productName}, quantity: ${lines[index].quantity}\n`
  }
  return message
}

export const errorMessage = (errorResponse, companyInfo, endpoint, body) => {
  const { companyName } = companyInfo
  let message = `Error: ${errorResponse?.message}\n`
  message += `Message: error calling ${endpoint}\n`
  message += `Company: ${companyName}\n`
  let subMessage = `${JSON.stringify(errorResponse)}\n`
  subMessage += body ? JSON.stringify(body) : ''
  sendBotMessage(message, subMessage)
}

export const removeIframeMessage = (companyInfo, permalink, reason, collectedScrapperInfo) => {
  const { companyName } = companyInfo
  let message = 'Error: Redirect to native checkout\n'
  message += `Case: ${reason}\n`
  message += `Company: ${companyName}\n`
  let subMessage = `Permalink: ${permalink}`
  if (collectedScrapperInfo.joined.length) {
    subMessage += '\n\nCollected Scrapper Info:'
    subMessage += `\nJoined: ${JSON.stringify(collectedScrapperInfo.joined)}`
    subMessage += `\nPrivate Messages: ${JSON.stringify(collectedScrapperInfo.privateMessages)}`
    subMessage += `\nPayment Url: ${JSON.stringify(collectedScrapperInfo.paymentUrl)}`
    subMessage += `\n\nSocket Messages: ${JSON.stringify(collectedScrapperInfo.socketMessages)}`
  }
  sendBotMessage(message, subMessage)
}

export const timeoutScrapperMessage = (companyInfo, cartData, userInfo, addressInfo) => {
  const { companyName } = companyInfo
  let message = 'Error: Redirect to cart\n'
  message += 'Case: Exceeded 6 minutes timeout of scrapper\n'
  message += `Company: ${companyName}\n`
  let subMessage = `${JSON.stringify(cartData)}\n`
  subMessage += `${JSON.stringify(userInfo)}\n`
  subMessage += `${JSON.stringify(addressInfo)}\n`
  sendBotMessage(message, subMessage)
}

export const sendTimeoutMessage = (companyInfo, caseText, userInfo, extraInfo) => {
  const { companyName } = companyInfo
  let message = 'Error: Timeout\n'
  message += `Case: ${caseText}\n`
  message += `Company: ${companyName}\n`
  let subMessage = `User Info: ${JSON.stringify(userInfo)}`
  if (extraInfo) {
    subMessage += `\n\nExtra Info: ${JSON.stringify(extraInfo)}`
  }
  sendBotMessage(message, subMessage)
}

export const socketDisconnectMessage = (companyInfo, userInfo) => {
  const { companyName } = companyInfo
  let message = 'Error: Socket disconnect mid-flow\n'
  message += `Company: ${companyName}\n`
  const subMessage = `User: ${userInfo?.email || 'unknown'}`
  sendBotMessage(message, subMessage)
}

export const unavailablePointMessage = (companyInfo, point, reason, context) => {
  const { companyName } = companyInfo
  const { requestBody, receivedServices = [] } = context
  let message = 'Punto de retiro no disponible al confirmar\n'
  message += `Company: ${companyName}\n`
  message += `Reason: ${reason}\n`
  message += `Punto: ${point?.title} (courierPointId ${point?.courierPointId ?? 'sin id'})\n`
  message += `Servicios recibidos: ${receivedServices.length}\n`
  message += 'Se recomienda actualizar los mapas de la empresa y revisar la configuracion del punto\n'
  const subMessage = JSON.stringify({
    deliveryCostRequest: { method: 'POST', path: '/delivery-cost', body: requestBody },
    point: {
      id: point?.id,
      cmsId: point?.cmsId,
      warehouseId: point?.warehouseId,
      title: point?.title,
      type: point?.type,
      courierPointId: point?.courierPointId,
      receivesFromCd: point?.receivesFromCd,
      activePickFromStore: point?.activePickFromStore
    },
    receivedServices: receivedServices.map(service => ({
      serviceType: service?.serviceType,
      deliveryType: service?.deliveryType,
      courierPointId: service?.courierPointId,
      price: service?.price
    }))
  })
  sendBotMessage(message, subMessage)
}
